// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p6-1";
export var messageSideRight = "_p6-2";
export var subscribeToBackInStockBubbleContainer = "_p6-0";